import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_SLICE_QUERY_KEY } from './useGetMerchandisingCollectionSlice';
import { MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY } from './useGetMerchandisingCollectionSliceProducts';
import { MERCHANDISING_COLLECTION_SLICES_QUERY_KEY } from './useGetMerchandisingCollectionSlices';

import MerchandisingCollectionsService, {
  UpdateMerchandisingCollectionSliceDto,
} from '@/services/MerchandisingCollectionsService';

export function useUpdateMerchandisingCollectionSlice() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      collectionId,
      sliceId,
      dto,
    }: {
      collectionId: number;
      sliceId: number;
      dto: UpdateMerchandisingCollectionSliceDto;
    }) => {
      return MerchandisingCollectionsService.updateSlice(
        collectionId,
        sliceId,
        dto,
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          ...MERCHANDISING_COLLECTION_SLICES_QUERY_KEY,
          variables.collectionId,
        ],
      });

      queryClient.invalidateQueries({
        queryKey: [
          ...MERCHANDISING_COLLECTION_SLICE_QUERY_KEY,
          variables.collectionId,
          variables.sliceId,
        ],
      });

      queryClient.invalidateQueries({
        queryKey: [
          ...MERCHANDISING_COLLECTION_SLICE_PRODUCTS_QUERY_KEY,
          variables.collectionId,
          variables.sliceId,
        ],
      });
    },
  });

  return {
    updateMerchandisingCollectionSlice: mutateAsync,
    isLoading: isPending,
  };
}
